module.exports = __webpack_public_path__ + "img/logo.809d10a9.png";